import type { IdeaAlertRowAction } from './actions';
import type { IdeaAlertRowState } from './types';

export function ideaAlertRowReducer(state: IdeaAlertRowState, action: IdeaAlertRowAction): IdeaAlertRowState {
    switch (action.type) {
        case 'SET_ENABLED':
            return { ...state, enabled: action.enabled };
        case 'SET_TRIGGER_MODE':
            return { ...state, triggerMode: action.triggerMode };
        case 'SET_SLOW_IDEA':
            return { ...state, slowIdeaId: action.slowIdeaId };
        case 'SET_FAST_IDEA':
            return { ...state, fastIdeaId: action.fastIdeaId };
        case 'SET_SHOW_TOAST':
            return { ...state, showToast: action.showToast };
        case 'SET_PLAY_SOUND':
            return { ...state, playSound: action.playSound };
        case 'SET_SOUND_TYPE':
            return { ...state, soundType: action.soundType };
        case 'SET_SPEAK_TTS':
            return { ...state, speakTts: action.speakTts };
        case 'SET_TTS_TEXT':
            return { ...state, ttsText: action.ttsText };
        case 'SET_TTS_VOICE_URI':
            return { ...state, ttsVoiceUri: action.ttsVoiceUri };
        case 'SET_TTS_RATE':
            return { ...state, ttsRate: action.ttsRate };
        case 'SET_TTS_PITCH':
            return { ...state, ttsPitch: action.ttsPitch };
        case 'SET_TTS_VOLUME':
            return { ...state, ttsVolume: action.ttsVolume };
        case 'SET_NOTE':
            return { ...state, note: action.note };
        case 'SYNC_FROM_DEFINITION':
            return {
                ...state,
                enabled: action.enabled,
                showToast: action.showToast,
                playSound: action.playSound,
                soundType: action.soundType,
                speakTts: action.speakTts,
                ttsText: action.ttsText,
                ttsVoiceUri: action.ttsVoiceUri,
                ttsRate: action.ttsRate,
                ttsPitch: action.ttsPitch,
                ttsVolume: action.ttsVolume,
                note: action.note,
                triggerMode: action.triggerMode,
                slowIdeaId: action.slowIdeaId,
                fastIdeaId: action.fastIdeaId,
            };
        default:
            return state;
    }
}
